import { inject, Injectable, signal } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { StaticSettings } from './static-settings';
import { Tenant } from '../interfaces/tenant';
import { tap } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class TenantService {
  private readonly _tenants = signal<Tenant[]>(null);
  tenants = this._tenants.asReadonly();

  private readonly _http = inject(HttpClient);
  private readonly _settings = inject(StaticSettings);

  public getTenants() {
    const endpointUrl = this._settings.getApiUrl('UserCenter/tenant/header');

    return this._http.get<Tenant[]>(endpointUrl).pipe(tap(tenants => this._tenants.set(tenants)));
  }
}
